module.exports = __webpack_public_path__ + "assets/img/box-bg2.175aa11c.png";